const path = "/rh/servidore";
const pathMatricula = "/rh/matricula";
export default {
  main: path,
  matricula: pathMatricula,
};
